<template>

  <asd20-card
    v-if="school"
    :title="school.title.replace(/(Elementary|Elementary-Middle|Middle|Middle-High|High|Elementary-Middle-High) School/, '<small>$1 School</small>')"
    :subtitle="school.distance && school.distance > 0.0 ? `${school.distance} miles away.` : `${school.address.street1}`"
    :image="school.exteriorPhotoUrl"
    :alt="`${school.title} exterior photo.`"
    class="asd20-school-card"
    hero
    separate-image
    @click.native="$emit('select', school)"
  >
    <template
      v-slot:bottom
    >
      <div
        class="card-actions">
        <asd20-button
          :link="'tel:' + school.phone"
          rel="noopener"
          label="Call"
          icon="phone"
          size="md"
          transparent
          class="hide-on-desktop"
        />
        <asd20-button
          :link="school.website"
          :aria-label="`${school.title} website`"
          rel="noopener"
          target="_blank"
          label="Website"
          icon="website"
          size="md"
          transparent
          class="hide-on-xs"
        />
        <asd20-button
          :link="`https://www.google.com/maps/search/?api=1&query=${school.address.street1}&origin_place_id=${school.name}`"
          :aria-label="`Directions to ${school.title}`"
          target="_blank"
          rel="noopener"
          label="Directions"
          icon="directions"
          size="md"
          transparent
        />
        <asd20-button
          :aria-label="`Learn more about ${school.title}`"
          label="Learn More"
          size="md"
          reversed
          horizontal
          centered
          @click.native="$emit('select', school)"
        />
      </div>
    </template>

  </asd20-card>

</template>

<script>
import Asd20Card from '@asd20/ui/src/components/molecules/Asd20Card'
import Asd20Button from '@asd20/ui/src/components/atoms/Asd20Button'

// import Asd20Progress from '@asd20/ui/dist/asd20-progress/asd20-progress.common'
// import '@asd20/ui/dist/asd20-progress/asd20-progress.css'

export default {
  name: 'Asd20SchoolCard',
  components: { Asd20Card, Asd20Button },
  props: {
    school: { type: Object, default: null }
  },
  data: () => {
    return{
      segments: [
        {
          label: 'Full',
          threshold: 0.0,
          background: '#fff'
        },
      ]
    }
  },
  computed: {
    totalSeatsOccupied() {
     return this.school.totalCapacity - this.school.totalOpenSeats
    },
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_variables.scss';

.hide-on-xs {
  display: none !important;
}
.hide-on-desktop {
  display: flex !important;
}
label {
  font-weight: 400;
}

.card-actions {
  position: relative;
  z-index: 1;
  background: white;
  border-top: 1px solid asd20-swatch('background-alt');

  display: flex;
  --website-icon__fill-color-reverse: #0e2c6c;
  --website-button__hover-foreground: #0e2c6c;
  & > :last-child {
    margin-left: auto;
    margin-right: space(0.5);
    align-self: center;
  }
}
.asd20-school-card.asd20-card--with-image {
  .asd20-card__content {
    .asd20-card__subtitle {
      color: var(--color__accent-t90) !important;
    }
  }
}
.asd20-school-card.asd20-card {
  box-shadow: 0 0 0 1px asd20-swatch('background-alt');
  cursor: pointer;

  .asd20-card__content {
    margin-top: space(4);
  }
  .asd20-card__image {
    bottom: space(2.9);
  }
  .asd20-progress{
    position: absolute;
    top: 0;
    right: space(.5);
    z-index: 2;
    width: 30%;

    .asd20-progress--flat{
      .asd20-progress__label{
        color: #fff;
      }
      progress {
        background-color: rbga(0, 0, 0, .8)
      }
    }
  }
}
@media (min-width: 340px) {
  .hide-on-xs {
    display: flex !important;
  }
}

@media (min-width: 768px) {
  .hide-on-desktop {
    display: none !important;
  }
}
</style>
